import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from './../../styles/constants';

export const useStyles = makeStyles(theme => ({
	firstColumn: {
		minWidth: '220px',
		marginTop: '6px',
		marginRight: theme.spacing(-10),
		paddingLeft: '4px'
	},
	secondColumn: {
		marginRight: theme.spacing(12),
		minWidth: '150px'
	},
	thirdColumn: {
		paddingLeft: '0px',
		paddingTop: '12px',
		minWidth: '286px'
	},
	fourthColumn: {
		fontWeight: 'bold',
		minWidth: '120px',
		paddingRight: '8px'
	},
	evalButton: {
		backgroundColor: COLORS.PRIMARY,
		color: COLORS.WHITE,
		textTransform: 'none',
		display: 'inline-block',
		alignSelf: 'flex-end',
		flexGrow: '1',
		marginTop: '0px',
		marginRight: '4px'
	},
	gutterBottomTitle: {
		marginBottom: theme.spacing(3)
	},
	filter: {
		marginBottom: theme.spacing(1.5)
	},
	filterGutterBottom: {
		marginBottom: theme.spacing(3)
	},
	filterRight: {
		display: 'flex',
		justifyContent: 'flex-end'
	},
	note: {
		marginTop: theme.spacing(2.5)
	}
}));

export const useHelperTextStylesForAmbientTemperature = makeStyles({
	root: {
		marginTop: '-29px',
		paddingTop: 0,
		paddingBottom: 0,
		fontSize: '16px',
		color: 'red'
	}
});

export const useHelperTextStylesForOutput = makeStyles({
	root: {
		marginTop: 0,
		paddingTop: 0,
		fontSize: '16px',
		color: 'red',
		height: '23px'
	}
});

export const useHelperTextStyles = makeStyles({
	root: {
		marginTop: '-25px',
		marginBottom: '2px',
		fontSize: '16px',
		color: 'red'
	}
});
